import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/admin/leave-type/setting",
        component: List,
        name: "admin-leave-type-setting",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/leave-type/:leave_type_id/detail/create",
        component: Edit,
        name: "admin-leave-type-detail-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/leave-type/:leave_type_id/detail/:id/edit",
        component: Create,
        name: "admin-leave-type-detail-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
